import VenoBox from 'venobox/dist/venobox.min'

// https://github.com/nicolafranchini/VenoBox

export default function () {
    new VenoBox({
        selector: '.venobox',
        infinigall: true,
        spinColor: '#82ae33',
    })
}
